import { DataTypeItem } from './datatype-hierarchi.model';
import { DataGroup } from "./DataGroup";
import { DataTypeAggregateGraphQlResponse, DataTypeDetailAggregateGraphQlResponse, DataTypeGroupGraphQlResponse } from '../graphQL/data-type-aggegate-GQL.response';

export class DataTypeMapper{

    public static dataTypeAggregateGQlResponseToDataTypeCollection(dataTypeCollection:DataTypeAggregateGraphQlResponse):DataTypeItem[] {

        if(dataTypeCollection === null || dataTypeCollection === undefined || dataTypeCollection.findTipoDatos=== null || dataTypeCollection.findTipoDatos=== undefined ){
            return [];
        }
        return dataTypeCollection.findTipoDatos.map(this.dataTypeDetailAggregateGQlResponseToDataTypeItem);
    }



    public static dataTypeDetailAggregateGQlResponseToDataTypeItem(dataTypeDetail:DataTypeDetailAggregateGraphQlResponse, language: any):DataTypeItem {

        if(dataTypeDetail === null || dataTypeDetail === undefined){
            return null;
        }
        let auxDataType: DataTypeItem = new DataTypeItem();
        switch(language) {
            case 'en':
                auxDataType.name = dataTypeDetail.nombre_en;
                break;
            case 'es':
                auxDataType.name = dataTypeDetail.nombre_es;
                break;
            default:
                auxDataType.name = dataTypeDetail.nombre_es;
        }
        auxDataType.uuid = dataTypeDetail.uuid;
        auxDataType.description = dataTypeDetail.descripcion;
        auxDataType.unity = dataTypeDetail.unidad;
        auxDataType.codigo = dataTypeDetail.codigo;
        auxDataType.hideCode = dataTypeDetail.hideCode
        if(auxDataType.codigo === null) {auxDataType.codigo = dataTypeDetail.uuid}
        auxDataType.decimalFactor = dataTypeDetail.factorDecimal;   
        auxDataType.displayField = dataTypeDetail.displayField;

        return auxDataType;
    }
    public static dataTypeAggregateGQLResToDataGroup(dataTypeAggregate:DataTypeGroupGraphQlResponse, language: any):DataGroup{

        if(dataTypeAggregate === null || dataTypeAggregate === undefined){
            return null;
        }
        let auxDataTypeGroup: DataGroup = new DataGroup()
        auxDataTypeGroup.uuid = dataTypeAggregate.uuid;
        switch(language) {
            case 'en':
                auxDataTypeGroup.name = dataTypeAggregate.nombre_en;
                break;
            case 'es':
                auxDataTypeGroup.name = dataTypeAggregate.nombre_es;
                break;
            default:
                auxDataTypeGroup.name = dataTypeAggregate.nombre_es;
        }        
        // auxDataTypeGroup.codigo = dataTypeAggregate.codigo;
        auxDataTypeGroup.hideCode = dataTypeAggregate.hideCode
        return auxDataTypeGroup;
    }

}